import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context';
import { IItem } from './types';

export function usePutItemMutation(itemId?: string) {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (item: Omit<IItem, 'id'> | IItem) =>
      fetch(`/api/item`, {
        method: 'PUT',
        body: JSON.stringify(item),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.user?.id_token}`,
        },
      }).then((res) =>
        res.json() as Promise<IItem>,
      ),
    mutationKey: ['putItem', itemId],
    onSuccess: () => {
      if (!itemId) {
        queryClient.invalidateQueries({ queryKey: ['items'] });
      }
      queryClient.invalidateQueries({ queryKey: ['item', itemId] });
    }
  });
}